import { useState } from 'react';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';

export const HoverCopyCell = ({ value, displayValue, label }) => {
  const [showFull, setShowFull] = useState(false);
  if (!value) return <span className="text-sm text-slate-400">-</span>;
  return (
    <div className="relative group" onMouseEnter={() => setShowFull(true)} onMouseLeave={() => setShowFull(false)}>
      <span className="text-sm font-mono text-slate-600 cursor-default">{displayValue}</span>
      {showFull && (
        <div className="absolute z-20 left-0 top-full mt-1 bg-slate-900 text-white text-xs rounded-lg px-3 py-2 shadow-lg flex items-center gap-2 whitespace-nowrap">
          <span className="font-mono">{value}</span>
          <button onClick={(e) => { e.stopPropagation(); navigator.clipboard.writeText(value); toast.success(`${label} copied!`); }} className="p-0.5 hover:bg-slate-700 rounded">
            <Copy className="w-3 h-3" />
          </button>
        </div>
      )}
    </div>
  );
};

export default HoverCopyCell;
